/**
 * Core
 */
import React from "react";
/**
 * Styles
 */
import "./InputGlobal.scss";

function InputGlobal({
  placeholder,
  className,
  name,
  type,
  onChange,
  id,
  onFocus,
  onBlur,
  value,
}) {
  return (
    <input
      autoComplete="off"
      type={type}
      placeholder={placeholder}
      className={className}
      name={name}
      onChange={onChange}
      id={id}
      onFocus={onFocus}
      value={value}
      onBlur={onBlur}
    />
  );
}

export default InputGlobal;
